module.exports = __webpack_public_path__ + "static/artfam-5d791df719f754ab2e7f65645c800aa3.svg";